// @flow
import * as React from "react";
import idx from "idx";
import querystring from "querystring";
import firebase from "firebase/app";
import "firebase/messaging";
import filter from "lodash/filter";
import { Route, Switch, type Location } from "react-router-dom";
import { apiCall } from "./common/fetch";
import withData from "./withData";
import OneSignalPopup from "./OneSignal/Popup";
import { Messages, Message } from "./Firebase";
import { TransitionGroup } from "react-transition-group";
import { SlideUpDown } from "./common/Animations";
import AnimateHeight from "react-animate-height";
import { connect } from "react-redux";

// const API_URL = "https://notifications-pusher-service.siamoption-staging.local";
// const API_URL = "https://notifications-pusher-service.irontrade-staging.local";

function createArtificialMessaging() {
  let token = null;
  let onTokenRefreshCallbacks = new Set();

  let messaging = {
    requestPermission() {
      return Promise.resolve();
    },
    getToken() {
      if (token != null) {
        return Promise.resolve(token);
      } else {
        return new Promise((resolve) => {
          function callback() {
            resolve(token);
            onTokenRefreshCallbacks.delete(callback);
          }
          onTokenRefreshCallbacks.add(callback);
        });
      }
    },
    onTokenRefresh(callback) {
      onTokenRefreshCallbacks.add(callback);
      return function() {
        onTokenRefreshCallbacks.delete(callback);
      };
    },
    onMessage() {
      return function() {
        return void 0;
      };
    },
  };

  window.NATIVE_APP_FIREBASE_UPDATE_TOKEN = function(freshToken) {
    token = freshToken;
    onTokenRefreshCallbacks.forEach((callback) => {
      callback();
    });
  };

  return messaging;
}

function isAndroidAppMessagingAvailable() {
  return (
    window.nativeInterface != null &&
    window.nativeInterface.getFirebaseToken != null
  );
}

function isIOSAppMessagingAvailable() {
  return (
    window.webkit != null &&
    window.webkit.messageHandlers != null &&
    window.webkit.messageHandlers["nativeInterface"] != null
  );
}

let messaging = null;

try {
  if (isAndroidAppMessagingAvailable()) {
    messaging = createArtificialMessaging();
    window.nativeInterface.getFirebaseToken(
      "window.NATIVE_APP_FIREBASE_UPDATE_TOKEN('%VALUE%')"
    );
  } else if (isIOSAppMessagingAvailable()) {
    messaging = createArtificialMessaging();
    window.webkit.messageHandlers["nativeInterface"].postMessage(
      JSON.stringify({
        function: "getFirebaseToken",
        param: "window.NATIVE_APP_FIREBASE_UPDATE_TOKEN('%VALUE%')",
      })
    );
  } else {
    switch (process.env.REACT_APP_DEPLOY_TARGET) {
      case "siamoption":
        firebase.initializeApp({
          apiKey: "AIzaSyBF3xYH9XJl7Hgpw7yLkjV68YwnRPwfwHM",
          authDomain: "siamtrade-b960e.firebaseapp.com",
          databaseURL: "https://siamtrade-b960e.firebaseio.com",
          projectId: "siamtrade-b960e",
          storageBucket: "siamtrade-b960e.appspot.com",
          messagingSenderId: "383961510884",
        });
        break;
      case "irontrade":
        firebase.initializeApp({
          apiKey: "AIzaSyCUVFxVwGLWD8SwVDaR4GeBAWbimWbk84U",
          authDomain: "iron-trade.firebaseapp.com",
          databaseURL: "https://iron-trade.firebaseio.com/",
          projectId: "iron-trade",
          storageBucket: "iron-trade.appspot.com",
          messagingSenderId: "242226853705",
        });
        break;
      case "eztrader":
        firebase.initializeApp({
          apiKey: "AIzaSyDKuIh80mr48AKhZPn2cM7UrXHNVZU_nyE",
          authDomain: "ez-trader.firebaseapp.com",
          databaseURL: "https://ez-trader.firebaseio.com",
          projectId: "ez-trader",
          storageBucket: "ez-trader.appspot.com",
          messagingSenderId: "166212058336",
        });
        break;
      default:
        break;
    }

    messaging = firebase.messaging();
  }
} catch (error) {
  console.warn("Failed initializing Firebase Cloud Messaging APIs");
}

// Функции для отправки вещей на наши серверы
function submitFCMToken(token, user_key) {
  console.log("yo token = " + token);
  return apiCall(
    "/push/register?" +
      querystring.stringify({
        type: "fcm",
        device: token,
        user: user_key,
      })
  );
}

export function unregisterFCMToken(token, user_key) {
  return apiCall(
    "/push/unregister?" +
      querystring.stringify({
        type: "fcm",
        device: token,
        user: user_key,
      })
  );
}

function submitSubscriptionReport(pathname) {
  console.log("subscribed @ " + pathname);
  // return apiCall("/api/fcm/subscription?page=" + encodeURIComponent(pathname));
}

function submitDismissalReport(pathname) {
  console.log("dismissed @ " + pathname);
  // return apiCall("/api/fcm/dismissal?page=" + encodeURIComponent(pathname));
}

// Показываем попап оповещений первые 2 раза, а после —
// каждый пятый
function shouldProposeSubscription(attempt) {
  return attempt === 0 || attempt === 1 || (attempt - 1) % 5 === 0;
}

// Безопасное чтение-запись локал стораджа
function getProposalCount() {
  try {
    let stored = localStorage.getItem("__FCMProposalCounter");

    if (stored != null) {
      return parseInt(stored, 10);
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
}

function setProposalCount(value) {
  try {
    localStorage.setItem("__FCMProposalCounter", value.toString(10));
  } catch (error) {
    // Ну нет так нет
  }
}

type Props = {
  user_key: string,
  location: Location,
};

export type FirebaseMessage = {
  token: string,
  notification: {
    title: string,
    body: string,
    icon?: ?string,
  },
  data: {
    type?: string,
    push_id: string,
  },
  priority: "normal" | string,
  fcmOptions?: {
    link?: string, // абсолютный путь
  },
};

type PushStatProps = {
  push_id: string,
  action: "click" | "close" | "view",
};

type State = {
  shouldPropose: boolean,
  hasSubscribed: boolean,
  messages: Array<?FirebaseMessage>,
};

// Компонент невидим по умолчанию, но рендерится в попап,
// когда приходит время
class FirebaseCloudMessaging extends React.Component<Props, State> {
  state = {
    shouldPropose: false,
    messages: [],
  };

  async refreshToken() {
    let token = await messaging.getToken();

    if (token != null) {
      this.props.dispatch({ type: "PRESERVE_FIREBASE_TOKEN", payload: token });
      await submitFCMToken(token, this.props.user_key);
    }
  }

  async requestPermission() {
    try {
      await messaging.requestPermission();
      this.refreshToken();
    } catch (error) {
      console.warn("Welp, no luck with notifications", error);
    }
  }

  async probe() {
    // Логика, по которой мы решаем, показать попап или нет
    try {
      let token = await messaging.getToken();

      if (token == null) {
        let proposalCount = getProposalCount();

        if (shouldProposeSubscription(proposalCount)) {
          this.setState({ shouldPropose: true });
        }

        setProposalCount(proposalCount + 1);
      } else {
        this.props.dispatch({
          type: "PRESERVE_FIREBASE_TOKEN",
          payload: token,
        });
        submitFCMToken(token, this.props.user_key);
      }
    } catch (error) {
      console.warn(error);
      // Пользователь заблокировал уведомления, не будем тревожить
    }
  }

  subscribe = () => {
    this.setState({ shouldPropose: false }, () => {
      submitSubscriptionReport(this.props.location.pathname);
      this.requestPermission();
    });
  };

  dismiss = () => {
    this.setState({ shouldPropose: false }, () => {
      submitDismissalReport(this.props.location.pathname);
    });
  };

  // Токен с течением времени может меняться, подписываемся на
  // messaging.onTokenRefresh, чтобы следить за этим процессом
  unsubscribeFromTokenRefresh = null;
  unsubscribeFromMessages = null;

  submitPushStat = ({ push_id, action }: PushStatProps) => {
    try {
      apiCall(
        "/api/send-push-stat?" +
          querystring.stringify({
            push_id,
            action,
          })
      );
    } catch (error) {
      console.error(error);
    }
  };

  filterMessageFromState = (message: FirebaseMessage) => {
    const filtered = filter(this.state.messages, (msg) => msg !== message);
    this.setState({
      messages: filtered,
    });
  };

  clickMessage = (
    e: SyntheticMouseEvent<HTMLElement>,
    message: FirebaseMessage
  ) => {
    this.submitPushStat({
      push_id: message.data.push_id,
      action: "click",
    });

    const redirect = idx(message, (message) => message.fcmOptions.link);

    if (redirect != null) {
      window.open(redirect, "_blank");

      this.filterMessageFromState(message);
    }
  };

  removeMessage = (
    e: SyntheticMouseEvent<HTMLElement>,
    message: FirebaseMessage
  ) => {
    e.stopPropagation();

    this.filterMessageFromState(message);

    this.submitPushStat({
      push_id: message.data.push_id,
      action: "close",
    });
  };

  componentDidMount() {
    this.probe();

    this.unsubscribeFromTokenRefresh = messaging.onTokenRefresh(() => {
      this.refreshToken();
    });

    const typesNotForTrade = ["demo_opclose", "real_opclose", "place_tourn"];

    const restrictedTypes = ["start_tourn", "finish_tourn", "add_news"];

    this.unsubscribeFromMessages = messaging.onMessage(
      (payload: FirebaseMessage) => {
        if (
          (window.location.pathname === "/trade" &&
            typesNotForTrade.includes(payload.data.type)) ||
          restrictedTypes.includes(payload.data.type)
        ) {
          return null;
        }

        this.setState((state) => ({
          messages: [...state.messages, payload],
        }));
      }
    );
  }

  componentWillUnmount() {
    if (this.unsubscribeFromTokenRefresh != null) {
      this.unsubscribeFromTokenRefresh();
    }

    if (this.unsubscribeFromMessages != null) {
      this.unsubscribeFromMessages();
    }
  }

  render() {
    let renderPopup = () => (
      <OneSignalPopup onAccept={this.subscribe} onDismiss={this.dismiss} />
    );

    return (
      <React.Fragment>
        {this.state.shouldPropose && (
          <Switch>
            <Route path="/" exact={true} render={renderPopup} />
            <Route path="/profile" render={renderPopup} />
            <Route path="/analytics" render={renderPopup} />
            <Route path="/helpdesk" render={renderPopup} />
          </Switch>
        )}

        <Messages>
          <TransitionGroup component={null} exit={false}>
            {this.state.messages.map((message: FirebaseMessage, i) => {
              const title = idx(
                message,
                (message) => message.notification.title
              );
              const body = idx(message, (message) => message.notification.body);
              const icon = idx(message, (message) => message.notification.icon);

              return (
                <SlideUpDown key={i}>
                  {(animationState) => (
                    <AnimateHeight
                      height={animationState === "entered" ? "auto" : 0}
                      duration={animationState === "exiting" ? 0 : 200}
                      animateOpacity={true}
                    >
                      <Message
                        title={title}
                        icon={icon}
                        onClick={(e) => this.clickMessage(e, message)}
                        onDismiss={(e) => this.removeMessage(e, message)}
                      >
                        {body}
                      </Message>
                    </AnimateHeight>
                  )}
                </SlideUpDown>
              );
            })}
          </TransitionGroup>
        </Messages>
      </React.Fragment>
    );
  }
}

// Всё это нам нужно лишь на определённых страницах
// и только когда есть активный профиль
function RoutedFirebaseCloudMessaging(props) {
  const user_key = idx(props, (props) => props.profile.user_key);

  if (messaging != null && user_key != null) {
    return (
      <Route>
        {(route) => (
          <FirebaseCloudMessaging
            location={route.location}
            user_key={user_key}
            dispatch={props.dispatch}
          />
        )}
      </Route>
    );
  }

  return null;
}

export default withData({ optional: ["profile"] })(
  connect()(RoutedFirebaseCloudMessaging)
);



// WEBPACK FOOTER //
// ./src/components/FirebaseCloudMessaging.js